import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=1c26ef20&scoped=true"
import script from "./Home.js?vue&type=script&lang=js&external"
export * from "./Home.js?vue&type=script&lang=js&external"
import style0 from "./Home.scss?vue&type=style&index=0&id=1c26ef20&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c26ef20",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotImage: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Image/Image.vue').default,HotHero: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/Hero/Hero.vue').default,HotPositionsHero: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/PositionsHero/PositionsHero.vue').default,HotLiveOnPassions: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/LiveOnPassions/LiveOnPassions.vue').default,HotLove: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/Love/Love.vue').default,HotGlobalLeader: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/GlobalLeader/GlobalLeader.vue').default,HotTestimonials: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/Testimonials/Testimonials.vue').default,HotSocials: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/Socials/Socials.vue').default,HotHomeFaq: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Organisms/HomeFaq/HomeFaq.vue').default})
